(function() {
  function getConfig() {
    var node = document.querySelector('script[data-plp-layout-config]');
    if (!node) return { prefix: '' };
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return { prefix: '' };
    }
  }

  function preselectMaterial() {
    if (!window.jQuery || !window.preselectedMaterial) return;
    $('.product-item:not([data-preselected]) .swatches [data-variant-title="' + window.preselectedMaterial + '"]').each(function() {
      $(this).closest('.product-item').attr('data-preselected', 'true');
      $(this).click();
    });
  }

  function extractCollectionPageMarkup(data) {
    var parsedNodes = $.parseHTML(data, document, true) || [];
    var $parsed = $(parsedNodes);
    var $collectionPage = $parsed.filter('.collection-page').first();
    if (!$collectionPage.length) {
      $collectionPage = $parsed.find('.collection-page').first();
    }
    if (!$collectionPage.length) return null;
    return $collectionPage.html();
  }

  function recalcSticky(reload) {
    if (reload) {
      $('.top-hheight').css('top', $('#header').outerHeight() - 1);
    }
    var navPaddingTop = 56;
    if (window.innerWidth > 800) {
      var viewportHeight = window.innerHeight - $('#header').outerHeight() - navPaddingTop;
      $('.plp-navigation .wrapper').css('max-height', viewportHeight);
    }
  }

  function recalcFilters() {
    setTimeout(function() {
      var top;
      if ($('.filters-spacer').length > 0 && $('.sticky-menu').length > 0) {
        top = $('#header').outerHeight() + $('.filters-spacer').outerHeight() + $('.sticky-menu').outerHeight() - 2;
      } else if ($('.filters-spacer').length > 0) {
        top = $('#header').outerHeight() + $('.filters-spacer').outerHeight() - 2;
      } else if ($('.sticky-menu').length > 0) {
        top = $('#header').outerHeight() + $('.sticky-menu').outerHeight() - 2;
      } else {
        top = $('#header').outerHeight() - 2;
      }
      $('#searchspring-header').css('top', top);
    }, 400);
  }

  function checkWidth() {
    if (window.innerWidth < 800) {
      $('.collection-wrapper .carousel').each(function() {
        if (!$(this).hasClass('slick-initialized')) {
          $(this).slick({
            autoplay: false,
            infinite: false,
            speed: 200,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: '20% 0 0.6em',
            responsive: [
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerPadding: '20% 0 0.5em'
                }
              }
            ]
          });
        }
      });
    } else {
      $('.collection-wrapper .carousel').each(function() {
        if ($(this).hasClass('slick-initialized')) {
          $(this).slick('unslick');
        }
      });
      $('.collection-wrapper .carousel').each(function() {
        if ($(this).hasClass('slick-initialized')) {
          $(this).slick('unslick');
        }
      });
    }
  }

  function toogleDesc() {
    var collectionTitle = document.querySelector('.collection_title');
    if (!collectionTitle || collectionTitle.dataset.boundToggleDesc === 'true') return;

    var description = collectionTitle.parentElement.parentElement.querySelector('.collection-desc');
    var descriptionWrap = description ? description.querySelector('.wrap') : null;
    if (!description || !descriptionWrap) return;

    collectionTitle.dataset.boundToggleDesc = 'true';
    collectionTitle.addEventListener('click', function() {
      if (collectionTitle.classList.contains('open')) {
        collectionTitle.classList.remove('open');
        setTimeout(function() {
          collectionTitle.classList.remove('open');
          description.classList.remove('open');
          description.style.maxHeight = '0px';
        }, 50);
      } else {
        collectionTitle.classList.add('open');
        setTimeout(function() {
          collectionTitle.classList.add('open');
          description.classList.add('open');
          description.style.maxHeight = descriptionWrap.scrollHeight + 'px';
        }, 50);
      }
    });
  }

  function setAnchorButtons() {
    var anchorButtons = document.querySelectorAll('.collection-anchor-button');
    if (!anchorButtons.length) return;

    var selectedPill;
    anchorButtons.forEach(function(anchor) {
      if (anchor.dataset.boundAnchorClick === 'true') return;
      anchor.dataset.boundAnchorClick = 'true';
      anchor.addEventListener('click', function() {
        var target = document.querySelector('.target-' + anchor.dataset.anchor);
        var url = anchor.dataset.link;
        if (target) target.scrollIntoView({ behavior: 'smooth' });
        if (selectedPill) selectedPill.classList.remove('selected');
        selectedPill = anchor;
        selectedPill.classList.add('selected');
        if (url) location.href = location.origin + url;
      });
    });
  }

  function setupReadMore() {
    var elm = document.querySelector('.collection-desc .description');
    var readMore = document.querySelector('.read-more.plus');
    var readLess = document.querySelector('.read-less.minus');
    if (!elm || !readMore || !readLess || elm.dataset.boundReadMore === 'true') return;

    elm.dataset.boundReadMore = 'true';
    var isTextClamped = function(element) {
      return element.scrollHeight > element.clientHeight;
    };

    readMore.addEventListener('click', function() {
      elm.classList.remove('clamped');
    });

    readLess.addEventListener('click', function() {
      elm.classList.add('clamped');
    });

    new ResizeObserver(function(e) {
      if (isTextClamped(e[0].target)) {
        if (readMore.classList.contains('hide')) readMore.classList.remove('hide');
        if (!readLess.classList.contains('hide')) readLess.classList.add('hide');
      } else if (!isTextClamped(e[0].target) && elm.classList.contains('clamped')) {
      } else {
        if (!readMore.classList.contains('hide')) readMore.classList.add('hide');
        if (readLess.classList.contains('hide')) readLess.classList.remove('hide');
      }
    }).observe(elm);
  }

  function initUiBindings() {
    $(document)
      .off('click.plpFiltersToggle')
      .on('click.plpFiltersToggle', '.filters-main-wrap .filters-general-trigger', function() {
        $(this).toggleClass('open');
        $(this).next('.content').slideToggle();
      });

    $(document)
      .off('click.plpSortToggle')
      .on('click.plpSortToggle', '.filters-main-wrap .sort-text', function() {
        $(this).toggleClass('open');
        $(this).next('.content').slideToggle();
      });
  }

  function initPlpLayout() {
    if (typeof window.initPlpAjaxContent === 'function') window.initPlpAjaxContent();
    recalcSticky();
    recalcFilters();
    checkWidth();
    toogleDesc();
    setAnchorButtons();
    setupReadMore();
    if (typeof window.initPlpNavigation === 'function') window.initPlpNavigation();
    if (typeof window.initPlpFilters === 'function') window.initPlpFilters();

    setTimeout(function() {
      preselectMaterial();
    }, 300);
  }

  function bindHistoryHandlers(config) {
    if (window.__plpLayoutHistoryBound) return;
    window.__plpLayoutHistoryBound = true;

    var isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
    if (true) return;

    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      var url = State.url;
      if (State.data.url) {
        url = State.data.url;
      }
      if (url.indexOf('/collections') >= 0 && url.indexOf('?view') < 0) {
        url += '?view=ajax';
      }

      $.ajax({ url: url }).done(function(data) {
        var collectionPageMarkup = extractCollectionPageMarkup(data);
        if (collectionPageMarkup === null) {
          window.location.href = url.replace(/\?view=[^&]+/g, '').replace(/&view=[^&]+/g, '');
          return;
        }

        $('.collection-page').html(collectionPageMarkup);
        setTimeout(function() {
          if (typeof moveBadge === 'function') moveBadge();
          initPlpLayout();
          $('body').removeClass('mode-overlay-transparent').css('cursor', 'default');
        }, 200);

        if ($(window).scrollTop() > $('.collection-wrapper').offset().top) {
          var scrollPx = $('.collection-wrapper').offset().top - 57;
          $.scrollTo(scrollPx, 500);
        }
      });
    });

    $(document)
      .off('click.plpNavigationAjax')
      .on('click.plpNavigationAjax', '.plp-navigation .trigger, .shop-all-trigger', function() {
        if ($(this).closest('.item').hasClass('active') || $(this).closest('.item').hasClass('disabled')) {
          return false;
        }
        $('body').addClass('mode-overlay-transparent').css('cursor', 'progress');
        var href = $(this).attr('href');
        var pageTitle = ' | ' + $(this).text();
        if (href.indexOf('?view=') >= 0) {
          href = href.substring(0, href.indexOf('?view=')) + '?view=' + config.prefix + 'ajax';
        } else if (href.indexOf('&view=') >= 0) {
          href = href.substring(0, href.indexOf('&view=')) + '&view=' + config.prefix + 'ajax';
        } else {
          href = href + '?view=' + config.prefix + 'ajax';
        }
        History.pushState({ url: href }, pageTitle, href.replace('?view=' + config.prefix + 'ajax', '').replace('&view=' + config.prefix + 'ajax', ''));
        return false;
      });

    $(document)
      .off('click.plpPaginationAjax')
      .on('click.plpPaginationAjax', '.pagination .trigger:not(.active):not(.disabled)', function() {
        if (isDesignMode) {
          return true;
        }
        $('body').addClass('mode-overlay-transparent').css('cursor', 'progress');
        var href = $(this).attr('href');
        var pageTitle = ' | ' + $(this).text();
        if (href.indexOf('?view=') >= 0) {
          href = href.substring(0, href.indexOf('?view=')) + '?view=' + config.prefix + 'no-categories-ajax';
        } else if (href.indexOf('&view=') >= 0) {
          href = href.substring(0, href.indexOf('&view=')) + '&view=' + config.prefix + 'no-categories-ajax';
        } else {
          href = href + '?view=' + config.prefix + 'no-categories-ajax';
        }
        History.pushState({ url: href }, pageTitle, href.replace('?view=' + config.prefix + 'no-categories-ajax', '').replace('&view=' + config.prefix + 'no-categories-ajax', ''));
        return false;
      });
  }

  $(function() {
    var config = getConfig();
    initUiBindings();
    initPlpLayout();
    bindHistoryHandlers(config);

    $(window)
      .off('resize.plpLayout')
      .on('resize.plpLayout', $.throttle(15, function() {
        checkWidth();
        recalcSticky(false);
        recalcFilters();
        toogleDesc();
      }));
  });
})();
